import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
apiKey: "AIzaSyAWVOaLTQxH_H_wxeGNkk-vUFoh3bqX-9Q",
  authDomain: "bitcoinwalet-26d41.firebaseapp.com",
  projectId: "bitcoinwalet-26d41",
  storageBucket: "bitcoinwalet-26d41.firebasestorage.app",
  messagingSenderId: "435590102151",
  appId: "1:435590102151:web:02f6e0b4e4564a849b8c22"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
